import { ConfidentialityLevel } from './types';

export interface FileUploadModel {
  readonly file: File;
  readonly documentName: string;
  readonly modelId: string;
  readonly confidentialityLevel: ConfidentialityLevel;
}
